import React, { useRef } from 'react';
import './ColorSwatchRow.css';

export const DEFAULT_SWATCH_COLORS = [
  '#ef4444', // red
  '#f97316', // orange
  '#f59e0b', // amber
  '#eab308', // yellow
  '#22c55e', // green
  '#14b8a6', // teal
  '#3b82f6', // blue
  '#8b5cf6', // purple
  '#ec4899', // pink
  '#78350f', // brown
  '#0f172a', // near-black
  '#ffffff', // white
];

/**
 * Fixed row of preset coloring-book swatches plus a "more colors" button that
 * opens a native <input type="color"> for a custom pick. Deliberately simpler
 * than split_canvas's HSV ColorWheel — matches the reference screenshot.
 */
export default function ColorSwatchRow({
  colors = DEFAULT_SWATCH_COLORS,
  value,
  onChange,
  large = false,
}) {
  const customInputRef = useRef(null);
  const normalizedValue = String(value || '').toLowerCase();
  const isCustomValue = !colors.some(
    (c) => String(c).toLowerCase() === normalizedValue
  );

  return (
    <div
      className={`color-swatch-row${large ? ' color-swatch-row--large' : ''}`}
      role="group"
      aria-label="Colour palette"
    >
      {colors.map((c) => {
        const active = String(c).toLowerCase() === normalizedValue;
        return (
          <button
            key={c}
            type="button"
            className={`color-swatch${active ? ' color-swatch--active' : ''}`}
            style={{ backgroundColor: c }}
            aria-pressed={active}
            aria-label={`Colour ${c}`}
            title={c}
            onClick={() => onChange?.(c)}
          />
        );
      })}
      <button
        type="button"
        className={`color-swatch color-swatch--more${isCustomValue ? ' color-swatch--active' : ''}`}
        aria-label="More colours"
        title="More colours"
        onClick={() => customInputRef.current?.click()}
      >
        {isCustomValue ? <span className="color-swatch--more-dot" style={{ backgroundColor: value }} /> : null}
      </button>
      <input
        ref={customInputRef}
        type="color"
        className="color-swatch-custom-input"
        value={isCustomValue ? value : '#ffffff'}
        onChange={(e) => onChange?.(e.target.value)}
        aria-label="Custom colour picker"
        tabIndex={-1}
      />
    </div>
  );
}
